import { httpRequest } from "services/build-request";

export const getIbFullInfo = async () => {
  const route = `customers/get-ib-full-info`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
};

export const updateIbWallet = async ({ walletId, walletImg }) => {
  const route = `customers/customer-wallet`;

  const formData = new FormData();
  formData.append('walletId', walletId);
  if (walletImg) {
    formData.append('walletImg', walletImg);
  }

  const { success, data, kindMessage } = await httpRequest({
    method: "PATCH",
    route,
    body: formData, 
  });

  return { success, data, kindMessage };
};

export const getReferred = async ({ pagination }) => {
  const route = `customers-v2/referred`;
  const { success, data } = await httpRequest({ route, headers: pagination });
  return { success, data };
};

export const getResourceKit = async () => {
  const route = `resource-kit`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
}

export const gerIPFReport = async () => {
  const route = `customers/ipf/reports`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
}

export const getCustomerDataForPayouts = async () => {
  const route = `customers/data-for-payouts`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
};

export const getAssociateInfo = async () => {
  const route = `customers-v2/associate-info-v2`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
};

export const getBenefitPurchases = async ({ pagination }) => {
  const route = `customers-v2/benefits-purchases/paginated-v2`;
  const { success, data } = await httpRequest({ route, headers: pagination });
  return { success, data };
};